import { messageTypes } from '../components/Messages';

export default (message, regularExpression) => (value) => {
    let result;
    const regexp =
        typeof regularExpression === 'string'
            ? new RegExp(regularExpression.trim())
            : regularExpression;

    if (value && !regexp.test(value)) {
        result = { title: message, type: messageTypes.error };
    }
    return result;
};
